import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class DownloadFileService {
    download = (downloadDocumentUrl: string, fileName: string): void => {
        const downloadAnchor = document.createElement("a");
        downloadAnchor.href = downloadDocumentUrl;
        downloadAnchor.setAttribute('target', '_blank');
        downloadAnchor.setAttribute("download", fileName);
        downloadAnchor.click();
    }
}